const formatDate = (date: Date): string => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.warn('formatDate called with invalid date:', date);
        return ''; // or return a fallback like '0000-00-00' if you prefer
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export default formatDate;


export const isDobValid = (dobValue: string): boolean => {
  if (!dobValue) return false;

  // Strict MM-DD-YYYY format
  const dobRegex = /^(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])-\d{4}$/;
  if (!dobRegex.test(dobValue)) return false;

  const [mm, dd, yyyy] = dobValue.split("-").map(Number);

  // Create a UTC date using Date.UTC which avoids local timezone issues
  const birthTimestamp = Date.UTC(yyyy, mm - 1, dd);
  const birthDate = new Date(birthTimestamp);

  // Validate the date hasn't rolled over (e.g., invalid 02-30 becomes 03-01)
  if (
    birthDate.getUTCFullYear() !== yyyy ||
    birthDate.getUTCMonth() !== mm - 1 ||
    birthDate.getUTCDate() !== dd
  ) {
    return false;
  }

  const now = new Date();
  const todayUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

  let age = new Date(todayUTC).getUTCFullYear() - yyyy;

  // Adjust age if birthday hasn't occurred yet this year
  const birthdayThisYear = Date.UTC(now.getUTCFullYear(), mm - 1, dd);
  if (todayUTC < birthdayThisYear) {
    age--;
  }

  return age >= 15 && age <= 100;
};

export const formatDateToMMDDYYYY = (dateInput: string | Date): string => {
  if (!dateInput) return '';

  if (typeof dateInput === 'string') {
    const mmddyyyyMatch = dateInput.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (mmddyyyyMatch) {
      return dateInput; // already in correct format
    }

    const mmddyyyyDashMatch = dateInput.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (mmddyyyyDashMatch) {
      const [_, mm, dd, yyyy] = mmddyyyyDashMatch;
      return `${mm}/${dd}/${yyyy}`;
    }

    // Try parsing ISO string like '2005-12-12'
    const isoMatch = dateInput.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const [_, yyyy, mm, dd] = isoMatch;
      return `${mm}/${dd}/${yyyy}`;
    }

    // Last resort: Date constructor (Safari safe)
    const parsed = new Date(dateInput);
    if (!isNaN(parsed.getTime())) {
      const mm = String(parsed.getMonth() + 1).padStart(2, '0');
      const dd = String(parsed.getDate()).padStart(2, '0');
      const yyyy = parsed.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    }

    return '';
  }

  if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
    const mm = String(dateInput.getMonth() + 1).padStart(2, '0');
    const dd = String(dateInput.getDate()).padStart(2, '0');
    const yyyy = dateInput.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  return '';
};

export const isValidDateString = (dateValue: string) => {
    if (!dateValue) return false;

    // Strict pattern check: mm-dd-yyyy
    const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (!dateRegex.test(dateValue)) return false;

    const [mm, dd, yyyy] = dateValue.split('-').map(Number);

    // Basic range check
    if (dd < 1 || dd > 31 || mm < 1 || mm > 12 || yyyy < 1000 || yyyy > 9999) {
        return false;
    }

    const parsedDate = new Date(yyyy, mm - 1, dd);
    return !isNaN(parsedDate.getTime());
};

export const isOptionalDateValid = (input: string): boolean => {
	if (!input || input === 'mm-dd-yyyy') return true;

	const regex = /^(0[1-9]|1[0-2])-([0][1-9]|[12][0-9]|3[01])-\d{4}$/;
	return regex.test(input);
};

export const toYYYYMMDD = (input: string | Date): string => {
    if (!input) return '';
  
    if (typeof input === 'string') {
      // If input is already MM-DD-YYYY
      const parts = input.split('-');
      if (parts.length === 3) {
        const [month, day, year] = parts;
        if (month.length === 2 && day.length === 2 && year.length === 4) {
          return `${year}-${month}-${day}`;
        }
      }
  
      // Try parsing string as date
      const d = new Date(input);
      if (!isNaN(d.getTime())) {
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
      } else {
        console.warn('Invalid date_of_birth string input:', input);
        return '';
      }
    } else if (input instanceof Date) {
      if (!isNaN(input.getTime())) {
        const mm = String(input.getMonth() + 1).padStart(2, '0');
        const dd = String(input.getDate()).padStart(2, '0');
        const yyyy = input.getFullYear();
        return `${yyyy}-${mm}-${dd}`;
      } else {
        console.warn('Invalid date_of_birth Date object:', input);
        return '';
      }
    }
  
    console.warn('Unsupported date_of_birth input type:', input);
    return '';
  };